import { encrypted, decrypted } from 'config/crypto';

export const setLocalStorageValue = (key, value) => localStorage.setItem(key, encrypted(value));;

export const getLocalStorageValue = (key) => localStorage.getItem(key) && decrypted(localStorage.getItem(key));

export function SignOut() {
  const store = getLocalStorageValue('selected-store-id')
  localStorage.clear()
  setLocalStorageValue('selected-store-id', store)
  window.location.reload()
}

export function decodeJWT(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Invalid JWT token', error);
    return {};
  }
}